import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['badge', 'showMore'];

  connect() {
    // Get connection ID if it exists (for original functionality)
    const connectionId = this.element.dataset.connectionId;

    // Initialize hidden field based on context
    if (connectionId) {
      // Original connection-based verticals
      this.hiddenField = this.element.querySelector(`#selected-verticals-${connectionId}`);
    } else {
      // New compatibility step using preferred_content_types
      this.hiddenField = this.element.querySelector('#opportunity_verticals');
      if (!this.hiddenField) {
        this.hiddenField = document.createElement('input');
        this.hiddenField.type = 'hidden';
        this.hiddenField.name = 'opportunity[preferred_content_types]';
        this.hiddenField.id = 'opportunity_verticals';
        this.element.appendChild(this.hiddenField);
      }
    }

    this.selectedVerticals = [];
    // If there are pre-selected verticals, load them
    if (this.hiddenField.value) {
      this.selectedVerticals = this.hiddenField.value.split(',');
      this.updateSelectedBadgesFromList();
    }

    setTimeout(() => {
      this.showFirstFiveBadges();
    }, 0);
  }

  // Add new method to update badge UI based on pre-selected verticals
  updateSelectedBadgesFromList() {
    this.selectedVerticals.forEach((vertical) => {
      const badge = this.badgeTargets.find((b) => b.dataset.vertical === vertical);
      if (badge) {
        const badgeDiv = badge.querySelector('.vertical-badge');
        const plusIcon = badge.querySelector('#plus-icon');
        badgeDiv.classList.add('text-white', 'bg-primary');
        plusIcon.classList.add('rotate-plus');
      }
    });
  }

  // Rest of the methods remain the same
  showFirstFiveBadges() {
    const badges = this.badgeTargets;
    if (badges.length > 0) {
      badges.slice(0, 5).forEach((badge) => badge.classList.remove('d-none'));
    }
  }

  toggleShowMore(event) {
    event.preventDefault();
    event.stopPropagation();
    const badges = this.badgeTargets;

    if (this.showMoreTarget.innerText === 'Show all') {
      badges.forEach((badge) => badge.classList.remove('d-none'));
      this.showMoreTarget.innerText = 'Show less';
    } else {
      badges.forEach((badge) => badge.classList.add('d-none'));
      this.showFirstFiveBadges();
      this.showMoreTarget.innerText = 'Show all';
    }
    return false;
  }

  select(event) {
    event.stopPropagation();
    event.preventDefault();

    const badge = event.currentTarget.querySelector('.vertical-badge');
    const plusIcon = badge.querySelector('#plus-icon');
    const vertical = event.currentTarget.dataset.vertical;

    if (badge.classList.contains('bg-primary')) {
      this.removeVerticalFromList(vertical, badge, plusIcon);
    } else {
      if (this.selectedVerticals.length >= 3) {
        alert('You can only select up to 3 verticals.');
        return;
      }
      this.addVerticalToList(vertical, badge, plusIcon);
    }

    this.updateHiddenField();
  }

  updateHiddenField() {
    this.hiddenField.value = this.selectedVerticals.join(',');
  }

  addVerticalToList(vertical, badge, plusIcon) {
    this.selectedVerticals.push(vertical);
    badge.classList.add('text-white', 'bg-primary');
    badge.classList.remove('border-double-1');
    plusIcon.classList.add('rotate-plus');
  }

  removeVerticalFromList(vertical, badge, plusIcon) {
    this.selectedVerticals = this.selectedVerticals.filter((item) => item !== vertical);
    badge.classList.add('border-double-1');
    badge.classList.remove('text-white', 'bg-primary');
    plusIcon.classList.remove('rotate-plus');
  }
}
